import { render, staticRenderFns } from "./VoteResult.vue?vue&type=template&id=4fa5f6e4&scoped=true"
import script from "./VoteResult.vue?vue&type=script&lang=js"
export * from "./VoteResult.vue?vue&type=script&lang=js"
import style0 from "./VoteResult.vue?vue&type=style&index=0&id=4fa5f6e4&prod&lang=scss"
import style1 from "./VoteResult.vue?vue&type=style&index=1&id=4fa5f6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5f6e4",
  null
  
)

export default component.exports